import { QRCodeSVG } from 'qrcode.react';
import { QrCode } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Popover, PopoverContent, PopoverTrigger,
} from '@/components/ui/popover';

interface QrCodeSheetProps {
  url: string;
}

export function QrCodeSheet({ url }: QrCodeSheetProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon" title="Show QR code">
          <QrCode className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-4 flex flex-col items-center gap-3" align="end">
        <p className="text-xs text-muted-foreground font-medium">Scan to open your public profile</p>
        <QRCodeSVG value={url} size={200} />
        <p className="text-[10px] text-muted-foreground text-center break-all max-w-[200px]">{url}</p>
      </PopoverContent>
    </Popover>
  );
}
